/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Bold_LabelInputs */



/**
* | output |
* | --- |
* | "Bold" |
*
* @param {Style_Guide_Manager_Bold_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_bold_label = /** @type {((inputs?: Style_Guide_Manager_Bold_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Bold_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gras")
	if (locale === "de") return /** @type {LocalizedString} */ ("Deutlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Grassetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смелый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atrevido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("大胆的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("大胆な")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बोल्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Audacioso")
	return /** @type {LocalizedString} */ ("Bold")
});